import { Protocol, ProtocolContent, ProtocolContentType, } from "../../entities";
import { isRecord, isReplaceChange } from "../types";
import GatewayParsingError from './GatewayParsingError';
import GatewayRecordParser, { RECORD_TYPE_EXTENSION } from './GatewayRecordParser';
import PropTransformer from './PropTransformer';
const LINKED_ENTRY_TYPE = 'linked';
export default class OldRecordsParser extends GatewayRecordParser {
    protocolTypeId;
    protocolContentTypeId;
    tag;
    constructor(protocolTypeId, protocolContentTypeId, tag, app) {
        super(app);
        this.protocolTypeId = protocolTypeId;
        this.protocolContentTypeId = protocolContentTypeId;
        this.tag = tag;
    }
    getProtocolType() {
        try {
            return this.localCache.getProtocolType(this.protocolTypeId);
        }
        catch (error) {
            throw new GatewayParsingError(`protocol type is not existing: ${error}`);
        }
    }
    handlesProtocol() {
        return false;
    }
    handlesRecord(record) {
        let extensions = [];
        if (isRecord(record)) {
            extensions = record.Extensions || [];
        }
        else if (isReplaceChange(record.Changes[0])) {
            extensions = record.Changes[0].ReplacementRecord.Extensions || [];
        }
        else {
            extensions = record.Changes[0].Extensions || [];
        }
        const recordTypeExtension = extensions.find((extension) => extension.Manufacturer === 'ANZ' && extension.Name === RECORD_TYPE_EXTENSION);
        if (recordTypeExtension) {
            return false;
        }
        return extensions.some((extension) => extension.Manufacturer === 'ANZ' &&
            extension.Name === 'Tags' &&
            extension.Value instanceof Array &&
            extension.Value.includes(this.tag));
    }
    createProtocol(timestamp, author, type, contents, books, position, sogCog) {
        return new Protocol({ timestamp, author, type, contents, books, position, sogCog });
    }
    parseProtocolContent(record) {
        const mappedProps = this.mapProps(record);
        const data = this.createData(mappedProps, record);
        const protocolContent = [
            new ProtocolContent({ type: ProtocolContentType.createRef(this.protocolContentTypeId), data }),
        ];
        return protocolContent;
    }
    mapProps(record) {
        const mappedProps = {};
        const propsMapping = this.getPropsMapping();
        Object.entries(propsMapping).forEach(([entryType, type]) => {
            const entry = record.Entries.find((entry) => entry.Type === entryType);
            if (entry === undefined) {
                return;
            }
            const isUnknown = entry.Unknown === 'yes';
            if (type instanceof PropTransformer) {
                const transformer = type;
                const data = transformer.fromGateway(entry.Value, isUnknown, record);
                Object.assign(mappedProps, data);
            }
            else if (!isUnknown) {
                Object.assign(mappedProps, { [`${String(type)}`]: entry.Value });
            }
        });
        return mappedProps;
    }
    getLinked(record) {
        const linkedEntry = record.Entries.find((entry) => entry.Type === LINKED_ENTRY_TYPE);
        if (!linkedEntry) {
            return undefined;
        }
        return Protocol.createRef(linkedEntry.Value);
    }
}
//# sourceMappingURL=OldRecordsParser.js.map